import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    login(userName, password) {
        return interfaceAjax({
            url: '/login/login',
            method: 'post',
            data: {userName, password}
        });
    },
    logout() {
        return interfaceAjax({
            url: "/login/logout"
        });
    },
    getUserInfo() {
        return interfaceAjax({
            url: "/admin/user/getUserInfo"
        });
    },
    userList(params,data) {
        return interfaceAjax({
            url: '/admin/user/list',
            params,
            data
        });
    },
    userUpdate(data) {
        return interfaceAjax({
            url: '/admin/user/userUpdate',
            data
        });
    },
    userAdd(data) {
        return interfaceAjax({
            url: '/admin/user/add',
            data
        });
    },
    userDelete(id) {
        return interfaceAjax({
            url: '/admin/user/delete',
            data: {id}
        });
    },
    updatePassword(oldPassword, password) {
        return interfaceAjax({
            url: "/admin/user/updatePassword",
            data:{oldPassword, password}
        });
    },
    departList(departmentType) {
        return interfaceAjax({
            url: '/admin/user/listDepart',
            params:{departmentType}
        });
    },
}
